import { createContext } from '@/utils';
import type { EntryModalState } from './types';

export const EntryModalContext = createContext<EntryModalState>(
  undefined,
  'EntryModalContext'
);
